import { action, computed, observable, runInAction, makeObservable } from 'mobx';
import { get, post, requests, patch } from '@partsbadger/utils';

import { CoatingsProps, FinishesProps } from '@partsbadger/types';

class FinishStore {
    finishes: Array<FinishesProps> = [];
    coatings: Array<CoatingsProps> = [];
    constructor() {
        makeObservable(this, {
            finishes: observable,
            getFinishes: action,
        });
    }

    getFinishes() {
        requests
            .get(`/customer/finishes/`)
            .then(data => {
                runInAction(() => {
                    this.finishes = data.results;
                });
            })
            .catch(error => {
                console.error(error);
            });
    }
}

const finishStore = new FinishStore();

export default finishStore;
